import {HttpClient} from '@angular/common/http';
import {Inject, Injectable, OnDestroy, Optional} from "@angular/core";
import {MsalBroadcastService, MsalGuardConfiguration, MsalInterceptorConfiguration, MsalService, MSAL_GUARD_CONFIG, MSAL_INTERCEPTOR_CONFIG} from "@azure/msal-angular";
import {Subject, Subscription} from 'rxjs';
import * as openid from '../../assets/config/open-id.auth.json';
import {User} from '../models/identity/user.model';
import {ConfigService} from './config.service';
import { AccountInfo, AuthenticationResult, InteractionRequiredAuthError, InteractionStatus, PopupRequest, RedirectRequest } from '@azure/msal-browser';
import { filter } from 'rxjs/internal/operators/filter';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import * as configData  from "../../assets/config/config.json";

@Injectable()
export class LoginService implements OnDestroy {
  isIframe = false;
  employeeLoggedIn = new Subject<boolean>();
  
  private isOpenId: boolean;
  private currentUser: User;
  private isInGroup: boolean;
  private readonly apiController = '/api/User/getcurrentuser';
  private readonly subscription = new Subscription();
  private readonly _destroying$ = new Subject<void>();

  constructor(
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    @Inject(MSAL_INTERCEPTOR_CONFIG) private msalInterceptorConfig: MsalInterceptorConfiguration,
    @Optional() private broadcastService: MsalBroadcastService,
    @Optional() private authService: MsalService,
    private httpClient: HttpClient,
    private readonly configService: ConfigService
  ) {
    this.isOpenId = configData.authenticationType == 1;
    this.init();
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
    this.subscription.unsubscribe();
  }

  init() {
    this.authService.handleRedirectObservable().subscribe();
    this.subscription
    .add(this.broadcastService.inProgress$.subscribe())
      .add(this.broadcastService.inProgress$
        .pipe(
          filter((status: InteractionStatus) => status === InteractionStatus.None),
          takeUntil(this._destroying$)
        )
        .subscribe(async _ => {
        const isLogged = this.authService.instance.getAllAccounts().length > 0;
        console.log(this.authService.instance.getActiveAccount());
        this.checkAndSetActiveAccount();
        if(!isLogged) return;
        this.httpClient.get(this.apiController).subscribe(x =>{
          this.currentUser = x;
          console.log(this.currentUser);
          this.employeeLoggedIn.next(true);
        }
        );  
      }));

  }

   async trySetCurrentUser(): Promise<boolean> { 
    if(this.isLoggedIn && !this.currentUser)
    {
      this.currentUser = await this.httpClient.get(this.apiController).toPromise();
      return true;
    }
    return this.isLoggedIn;
   }

  getCurrent() {

    return this.currentUser;
  }

  getAccount() {
    return this.authService.instance.getActiveAccount();
  }

  checkAndSetActiveAccount(){
    const activeAccount = this.authService.instance.getActiveAccount();
    if (!activeAccount && this.authService.instance.getAllAccounts().length > 0) {
      const accounts = this.authService.instance.getAllAccounts();
      this.authService.instance.setActiveAccount(accounts[0]);
    }
  }

  async login() {

    if (!this.isOpenId) return;
    const isIE =
      window.navigator.userAgent.indexOf("MSIE ") > -1 ||
      window.navigator.userAgent.indexOf("Trident/") > -1;
    if (isIE) {
      await this.loginRedirect();
    } else {
      await this.loginPopup();
    }
  }

  async loginRedirect() {
    if (this.msalGuardConfig.authRequest){
    await this.authService.loginRedirect({...this.msalGuardConfig.authRequest} as RedirectRequest).toPromise();
    } else {
    await  this.authService.loginRedirect().toPromise();
    }
  }

  async loginPopup() {

    const account = this.msalGuardConfig.authRequest ?
    (await this.authService.loginPopup({...this.msalGuardConfig.authRequest} as PopupRequest).toPromise()).account :
    (await this.authService.loginPopup().toPromise()).account
    if(!!account){
      this.authService.instance.setActiveAccount(account);
    }
  }

  get isLoggedIn() {
    return !!this.authService.instance.getActiveAccount()
  }

  logout(popup?: boolean) {
    if (popup) {
      this.authService.logoutPopup({
        mainWindowRedirectUri: "/"
      });
    } else {
      this.authService.logoutRedirect();
    }
  }

  get getUser(): User {
    return this.currentUser;
  }

  get isUserInGroup(): boolean {
    return this.isInGroup;
  }


}
